module.exports = "<div class=\"cover-card-element\">\n  <div class=\"bg-image\" *ngIf=\"cover?.jpg_image\">\n    <img [src]=\"'http://46.22.221.22:3001/' + cover?.jpg_image\">\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cover-card/cover-card.component.html
// module id = 207
// module chunks = 1